/* eslint-disable complexity */
import { typedMemo } from "src/types";
import "./header.scss";

import { Image } from "react-bootstrap";
import { ItasLogo } from "src/assets";
import { AR_LINK } from "src/config";

export const Header = typedMemo(() => {
  const Logo = (
    <Image
      className={"header-logo"}
      src={ItasLogo}
      onClick={() => {
        window.location.replace(AR_LINK);
      }}
    />
  );

  return (
    <div>
      <header className="header-navbar">
        <div className="container">{Logo}</div>
      </header>
    </div>
  );
});
